export const MARKETS = {
	CHILE: "cl",
}

export const MARKET_CURRENCIES: Record<string, string> = {
	DEFAULT: "USD",
	[MARKETS.CHILE]: "CLP",
}
